import { type UpdateCreditTypeRequestPayload } from '@vy/api-definition';
import { useMutation, useQueryClient, type UseMutationOptions } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidateProductsQueries } from '../../utils/query-invalidation';

type UpdateCreditTypeVariables = {
  creditTypeId: string;
  updateCreditTypeRequest: UpdateCreditTypeRequestPayload;
};

export function useUpdateCreditType(
  options?: UseMutationOptions<void, unknown, UpdateCreditTypeVariables>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ creditTypeId, updateCreditTypeRequest }: UpdateCreditTypeVariables) => {
      const api = getPrivateApi();
      await api.updateCreditType({ creditTypeId, updateCreditTypeRequest });
    },
    onSuccess: async () => {
      await invalidateProductsQueries(queryClient);
    },
    ...options,
  });
}
